<template>
<div>
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: 'App',
    methods: {
        saveState() {
            alert('unload事件触发！');
            localStorage.setItem('state', JSON.stringify(this.$store.state));
        }
    },
    mounted() {
        window.addEventListener('unload', this.saveState)
    },
}
</script>






// WEBPACK FOOTER //
// src/App.vue